module.exports = __webpack_public_path__ + "asset/img/warning-white.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/images/warning-white.svg
// module id = 267
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 24 25 26 27 29 30 31 32 33 35 36 38 39 40 41 42 43 44 45 46 47 48 49 50 52 56 58 59 62 63